<template>
  <div class="reports">
    <progress-bar :progress="progress"/>
    <transition name="fade" mode="out-in">
      <component :is="currentUploadComponent" @to="toState" />
    </transition>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue'
import ReportsSelect from '@/views/ReportsSelect.vue'
import ReportsDone from '@/views/ReportsDone.vue'

export default {
  name: 'reports',
  components: {
    ProgressBar,
    ReportsSelect,
    ReportsDone
  },
  data() {
    return {
      state: 'select'
    }
  },
  computed: {
    currentUploadComponent() {
      return 'reports-' + this.state.toLowerCase()
    },
    progress() {
      switch (this.state) {
        case 'select': return 0.5
        case 'done': return 1
        default: return 0
      }
    }
  },
  methods: {
    toState($event) {
      if ($event === 'previous') this.state = 'platform'
      else this.state = $event
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.reports {
  text-align: center;

  /deep/ header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .flow-btn {
      text-align: left;
      flex: 0 0 20%;
    }

    .title {
      margin: auto;

      h1 {
        margin-bottom: em(7, 32);

        & + p {
          margin: 0;
        }
      }

      & + .flow-btn {
        text-align: right;
      }
    }
  }
}
</style>
